module.exports = __webpack_public_path__ + "eaf9c22471a60304940d9acce3f1314d.svg";